<template>
  <div class="body">
    <div class="main_container">
     <training-header></training-header>

      <!-- page content -->
      <div class="right_col" role="main" style="margin-left: 2px;">
        <div class="row px-4 pt-4">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="x_panel">
              <div class="x_content">
                <div class="process_steps">
                  <ul class="steps">
                    <li class="active">
                      <div>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span>Download</span>
                      </div>
                    </li>
                    <li class="active">
                      <div>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span>Customize</span>
                      </div>
                    </li>
                    
                    <li class="active">
                      <div>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span>Complete</span>
                      </div>
                    </li>
                    
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="x_panel">
              <div class="x_title">
                <ul class="nav nav-pills nav-justified" id="pills-tab" role="tablist">
                  <li class="nav-item">
                    <a data-toggle="tab" href="#home" class="nav-link active text-center" style="border-radius:10px 0 0 0;">Agenda</a>
                  </li>
                  <li class="nav-item">
                    <a data-toggle="tab" href="#menu1" class="nav-link text-center">Didatic Sessions</a>
                  </li>
                  <li class="nav-item">
                    <a data-toggle="tab" href="#menu2" class="nav-link text-center" style="border-radius:0 10px 0 0;">Online Sessions</a>
                  </li>
                </ul>

                <div class="clearfix"></div>
              </div>
              <div class="x_content mb-3">
                <div class="dashboard-widget-content" style="padding-top: 3%; padding-bottom: 2%;">
                  <div class="tab-content">
                    <div id="home" class="tab-pane container active">
                      <div class="row d-none">
                        <div class="col-xl-3 col-sm-4">
                          <div
                            class="panel panel-default panel-card"
                            style="background-color: #50abc9; border-color: #50abc9;"
                          >
                            <div
                              class="panel-heading"
                              style="background-color: #50abc9;border-color: #50abc9;"
                            >Basic concepts of AEFI and its application to generate data</div>
                            <div class="panel-body" style="background: #3c5162;">
                              <div class="panel-img">
                                <img src="../assets/img/agenda_session_img3.png" class="img-responsive" />
                              </div>
                              <ul>
                                <li>Learn about the basic concepts and its application</li>
                                <li>Includes key definitions, AEFI classification, types, reporting & AEFI surveillance cycle</li>
                              </ul>
                            </div>
                            <div
                              class="panel-footer"
                              style="background-color: #50abc9;
                                                    border-color: #50abc9;"
                            ><a style="color: #ffffff" href="https://uat.intraavenir.duredemos.com/docs/9pill.ppt">Download</a></div>
                          </div>
                        </div>
                        <div class="col-xl-3 col-sm-4">
                          <div
                            class="panel panel-default panel-card"
                            style="background-color: #50abc9; border-color: #50abc9;"
                          >
                            <div
                              class="panel-heading"
                              style="background-color: #50abc9;border-color: #50abc9;"
                            >Basic concepts of AEFI and its application to generate data</div>
                            <div class="panel-body" style="background: #3c5162;">
                              <div class="panel-img">
                                <img src="../assets/img/agenda_session_img3.png" class="img-responsive" />
                              </div>
                              <ul>
                                <li>Learn about the basic concepts and its application</li>
                                <li>Includes key definitions, AEFI classification, types, reporting & AEFI surveillance cycle</li>
                              </ul>
                            </div>
                            <div
                              class="panel-footer"
                              style="background-color: #50abc9;
                                                    border-color: #50abc9;"
                            ><a style="color: #ffffff" href="https://uat.intraavenir.duredemos.com/docs/9pill.ppt">Download</a></div>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div
                            class="panel panel-default panel-card"
                            style="background-color: #50abc9; border-color: #50abc9;"
                          >
                            <div
                              class="panel-heading"
                              style="background-color: #50abc9;border-color: #50abc9;"
                            >Basic concepts of AEFI and its application to generate data</div>
                            <div class="panel-body" style="background: #3c5162;">
                              <div class="panel-img">
                                <img src="../assets/img/agenda_session_img3.png" class="img-responsive" />
                              </div>
                              <ul>
                                <li>Learn about the basic concepts and its application</li>
                                <li>Includes key definitions, AEFI classification, types, reporting & AEFI surveillance cycle</li>
                              </ul>
                            </div>
                            <div
                              class="panel-footer"
                              style="background-color: #50abc9;
                                                    border-color: #50abc9;"
                            ><a style="color: #ffffff" href="https://uat.intraavenir.duredemos.com/docs/9pill.ppt">Download</a></div>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div
                            class="panel panel-default panel-card"
                            style="background-color: #50abc9; border-color: #50abc9;"
                          >
                            <div
                              class="panel-heading"
                              style="background-color: #50abc9;border-color: #50abc9;"
                            >Basic concepts of AEFI and its application to generate data</div>
                            <div class="panel-body" style="background: #3c5162;">
                              <div class="panel-img">
                                <img src="../assets/img/agenda_session_img3.png" class="img-responsive" />
                              </div>
                              <ul>
                                <li>Learn about the basic concepts and its application</li>
                                <li>Includes key definitions, AEFI classification, types, reporting & AEFI surveillance cycle</li>
                              </ul>
                            </div>
                            <div
                              class="panel-footer"
                              style="background-color: #50abc9;
                                                    border-color: #50abc9;"
                            ><a style="color: #ffffff" href="https://uat.intraavenir.duredemos.com/docs/9pill.ppt">Download</a></div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12 mb-2">
                          <export-excel :data = "items">
                            <button class="btn btn-primary btn-sm">
                              Download Agenda
                            </button>
                          </export-excel>
                      </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <b-table striped bordered hover :items="items"></b-table>
                        </div>
                      </div>
                    </div>
                    <div id="menu1" class="tab-pane container fade">
                      <div class="row"  v-if="planningData">
                        <div class="col-xl-3 col-sm-4" v-for="(data, i) in planningData[0].headers" :key="i">
                          <div
                            class="panel panel-default panel-card"
                            style="background-color: #50abc9; border-color: #50abc9;"
                          >
                            <div
                              class="panel-heading"
                              style="background-color: #50abc9;border-color: #50abc9;"
                            >{{data.header}}</div>
                            <div class="panel-body" style="background: #3c5162;">
                              <div class="panel-img">
                                <img src="../assets/img/agenda_session_img3.png" class="img-responsive" />
                              </div>
                              <ul>
                                <li v-for="(con, j) in data.contents" :key="j">{{con.contentBody}}</li>
                              </ul>
                            </div>
                            <div
                              class="panel-footer"
                              style="background-color: #50abc9;
                              border-color: #50abc9;"
                            ><a :href="data.downloadLink" style="color: #ffffff">Download</a></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id="menu2" class="tab-pane container fade">
                      <div class="row"  v-if="planningData">
                        <div class="col-xl-3 col-sm-4" v-for="(data, i) in planningData[0].headers" :key="i">
                          <div
                            class="panel panel-default panel-card"
                            style="background-color: #50abc9; border-color: #50abc9;"
                          >
                            <div
                              class="panel-heading"
                              style="background-color: #50abc9;border-color: #50abc9;"
                            >{{data.header}}</div>
                            <div class="panel-body" style="background: #3c5162;">
                              <div class="panel-img">
                                <img src="../assets/img/agenda_session_img3.png" class="img-responsive" />
                              </div>
                              <ul>
                                <li v-for="(con, j) in data.contents" :key="j">{{con.contentBody}}</li>
                              </ul>
                            </div>
                            <div
                              class="panel-footer"
                              style="background-color: #50abc9;
                              border-color: #50abc9;"
                            ><a :href="data.downloadLink" style="color: #ffffff">Download</a></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="text-align: center; margin-bottom: 3%;margin-top: 1%; padding-bottom:5%;">
                <a href="#/facilitator-course" class="btn-bottom" style="margin-right: 5%;">
                  <i class="fa fa-angle-double-left" aria-hidden="true" style="padding-right: 1%;"></i> Previous
                </a>
                <a href="http://avenirtraining.duredemos.com/service/dhis-web-commons/security/login.action" class="btn-bottom" role="button" style="color: #3471CE;">
                  Next
                  <i class="fa fa-angle-double-right" aria-hidden="true" style="padding-left: 1%;"></i>
                </a>
                <!-- <a href="login.html" class="btn btn-cust1 btn-md btn3d" role="button">Login to   Harmonia</a> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /page content -->

      <!-- footer content -->
      <training-footer></training-footer>

      <!-- /footer content -->
    </div>
  </div>
</template>
<script>
import trainingHeader from '../components/trainingHeader';
import trainingFooter from '../components/trainingFooter';
import ApiServices from '../service/ApiServices';
export default {
    components: {
        trainingHeader, 
        trainingFooter
    },
    data(){
      return {
        masterAgenda: JSON.parse(localStorage.getItem("userAgenda")),
        items: [
          { MODULE: '', FACILITATOR: '', FROM: '', TO: '', GOALS: '', TOPIC: 'Registration' }
        ],
        fields: [
          {
            key: 'MODULE',
            label: 'MODULE',
            sortable: true
          },
          {
            key: 'FACILITATOR',
            label: 'FACILITATOR'
          },
          {
            key: 'FROM',
            label: 'FROM'
          },
          {
            key: 'TO',
            label: 'TO'
          },
          {
            key: 'GOALS',
            label: 'GOALS'
          },
          {
            key: 'TOPIC',
            label: 'TOPIC'
          }
        ],
        planningData: null
      }
    },
    methods: {
      getAgenda(){
        this.masterAgenda.forEach((agenda, i)=>{
          this.items.push(
            { MODULE: agenda.module, FACILITATOR: agenda.facilatior, FROM: agenda.fromTime, TO: agenda.toTime, GOALS: agenda.goals, TOPIC: agenda.agenda }
          )
        })
      },
      getPlanningData(){
        this.$root.loading = true;
        ApiServices.RestPostCall('api/avenir/training/getPlanningData',{}).then(res=>{
          this.planningData = res.masterAgenda
          this.$root.loading = false;
        })
      }
    },
    mounted(){
      this.getAgenda()
      this.getPlanningData()
    }
}
</script>
<style scoped>
    .x_panel {
        background-color: #fff !important;
        border: 0px solid transparent;
        padding:0 !important;
        border-radius: 10px;
    }
    .x_title {
        border-bottom: 0px solid #E6E9ED;
        padding: 0 !important;
        background-color: #b0b0b0;
        color: #fff;
        border-radius: 10px 10px 0 0;
    }
    .x_content {
        padding: 0px 25px 6px;
    }
    .panel-img img{
        width: 100px;
        margin: 10px auto;
    }
    .dashboard-widget-content{
        height: 350px;
        overflow: hidden;
        overflow-y: scroll;
    }
</style>